import axios from "axios";
import * as XLSX from "xlsx";
import "./expenseOverview.css";
import Select from 'react-select';
import Modal from "react-modal";
import { DatePicker } from "rsuite";
import subDays from "date-fns/subDays";
import moment from "moment-timezone";
import { DateRangePicker } from "rsuite";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import isEqual from 'lodash/isEqual';
import { useSelector, useDispatch } from 'react-redux';
import ExpenseOverviewTotal from "./expenseOverviewTotal";
import ExpenseOverviewGraph from "./expenseOverviewGraph";
import ExpenseOverviewPieChart from "./expenseOverviewPiechart";
import ExpenseTable from "./expenseTable";
import React, { useState, useRef, useEffect } from "react";
import { useQueryClient } from 'react-query';
import userTypeConsts from "../../constants/userTypeConsts";
import DownloadImage from "../../images/icons/download-icon.svg";
import PlusIcon from "../../images/icons/plus-icon.svg";
import Plus from "../../images/icons/plus-black.svg";
import Close from "../../images/icons/black-close.svg";
import Tick from "../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import TruncateFilterFieldView from "../../components/helpers/truncateFilterFieldView.js";
import Currencies from "../../constants/currenciesList.js";
import { useGetClients, useGetProjects, useGetDepartments, useGetTeams, useGetActiveTeams, useGetExpenseClients, useGetExpenceDepartments } from "../../components/TimeTracker/TimeTrackerOverview/useTimeTracker.jsx";
import { setExpTeam, setExpClient, setExpProject, setExpDepartment, setFilterExpCategory, setFilterExpCurrency, setExpenseData, setFilterExpStatus } from "../../features/expenseData/expenseDataSlice.js";
import { useFetchExpCategory } from "../../components/AppSettings/expenseCategoryApi.jsx";
import { useGetExpenseData, useExpenseId } from "../../features/expenseData/useExpenseData.jsx";
import { setNotification } from "../../features/notification/notificationSlice.js";
import { logout, reset } from "../../features/auth/authSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import { setDashboardCurrencyRx, setDashboardCurrencySum } from "../../features/invoice/invoiceSlice";
import Calendar from "../../helpers/dateComponents/Calendar";
import { setForex } from "../../features/forex/forexSlice.js";
import { useFetchDashboardCurrency } from "../../components/Dashboard/DashboardCurrencyApi";
import getCurrencyByCode from 'currency-codes';
import { RotatingLines } from 'react-loader-spinner';
import { motion } from 'framer-motion';
import { useWXCompanies } from "../../components/User/UserDetails/UserProfile/useUserView.jsx";

const ranges = [
  {
    label: "today",
    value: new Date(), // Use a single date instead of an array
  },
  {
    label: "yesterday",
    value: subDays(new Date(), 1),
  },
];

const expenseStatusList = [
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "pending", label: "Pending" },
];

const ExpenseOverview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dates, setDates] = useState(new Date());
  const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  const startOfYear = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0);
  const endOfYear = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999);
  const endOfToday = new Date();
  endOfToday.setHours(23, 59, 59, 999);
  const [expDescription, setExpDescription] = useState("");
  const [showCalendar, setShowCalendar] = useState(false);
  const [showModalCalendar, setShowModalCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([startOfYear, endOfToday]);
  const [perPage, setPerPages] = useState(10);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const expenseData = useSelector((state) => state.expenseData)
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [expenseDate, setExpenseDate] = useState(null);
  const [expCategory, setExpCategory] = useState("");
  const [expCurrency, setExpCurrency] = useState("");
  const [expSubTotal, setExpSubTotal] = useState("");
  const [expTax, setExpTax] = useState("");
  const [expAmount, setExpAmount] = useState(0);
  const [expIsBillable, setExpIsBillable] = useState(true);
  const [expenseUser, setExpenseUser] = useState("");
  const [expenseClient, setExpenseClient] = useState("");
  const [expenseProject, setExpenseProject] = useState("");
  const [expenseCompany, setExpenseCompany] = useState("");
  const [expNote, setExpNote] = useState("");
  const [expFileAttchFiles, setExpFileAttchFiles] = useState([]);
  const [expFileAttchFileName, setExpFileAttchFileName] = useState("");
  const [expCurrencySearchTerm, setExpCurrencySearchTerm] = useState('');
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [expCurrencyDropdownOpen, setExpCurrencyDropdownOpen] = useState(false);
  const [expenseCategoryDropdownOpen, setExpenseCategoryDropdownOpen] = useState(false);
  const [expenseUserDropdownOpen, setExpenseUserDropdownOpen] = useState(false);
  const [expClientDropdownOpen, setExpClientDropdownOpen] = useState(false);
  const [expClientSearchTerm, setExpClientSearchTerm] = useState('');
  const [expProjectDropdownOpen, setExpProjectDropdownOpen] = useState(false);
  const [expProjectSearchTerm, setExpProjectSearchTerm] = useState('');
  const [expCompanyDropdownOpen, setExpCompanyDropdownOpen] = useState(false);
  const [expCompanySearchTerm, setExpCompanySearchTerm] = useState('');
  const [expenseDescriptionIsValid, setExpenseDescriptionIsValid] = useState(false);
  const [expenseCurrencyIsValid, setExpenseCurrencyIsValid] = useState(false);
  const [expSubTotalIsValid, setExpSubTotalIsValid] = useState(false);
  const [expTaxIsValid, setExpTaxIsValid] = useState(false);
  const [expenseDateIsValid, setExpenseDateIsValid] = useState(false);
  const [expenseCategoryIsValid, setExpenseCategoryIsValid] = useState(false);
  const [expenseUserIsValid, setExpenseUserIsValid] = useState(false);
  const [expenseClientIsValid, setExpenseClientIsValid] = useState(false);
  const [expenseCompanyIsValid, setExpenseCompanyIsValid] = useState(false);
  const componentRef = useRef();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [expCurrencyList, setExpCurrencyList] = useState([]);
  const [selectAllTeam, setSelectAllTeam] = useState(true);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [isTeamDropdownOpen, setIsTeamDropdownOpen] = useState(false);
  const [isTeamModalDropdownOpen, setIsTeamModalDropdownOpen] = useState(false);
  const [userDropdownSearchTerm, setUserDropdownSearchTerm] = useState('');
  const [selectAllClient, setSelectAllClient] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [isClientModalDropdownOpen, setIsClientModalDropdownOpen] = useState(false);
  const [clientDropdownSearchTerm, setClientDropdownSearchTerm] = useState('');
  const [selectAllProject, setSelectAllProject] = useState(true);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
  const [isProjectModalDropdownOpen, setIsProjectModalDropdownOpen] = useState(false);
  const [selectAllDept, setSelectAllDept] = useState(true);
  const [selectedDepts, setSelectedDepts] = useState([]);
  const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
  const [departmentDropdownSearchTerm, setDepartmentDropdownSearchTerm] = useState('');
  const [isDeptModalDropdownOpen, setIsDeptModalDropdownOpen] = useState(false);
  const [selectAllExpCategory, setSelectAllExpCategory] = useState(true);
  const [selectedExpCategories, setSelectedExpCategories] = useState([]);
  const [isExpCategoryDropdownOpen, setIsExpCategoryDropdownOpen] = useState(false);
  const [isExpCategoryModalDropdownOpen, setIsExpCategoryModalDropdownOpen] = useState(false);
  const [categoryDropdownSearchTerm, setCategoryDropdownSearchTerm] = useState('');
  const [selectAllExpCurrencyFilter, setSelectAllExpCurrencyFilter] = useState(true);
  const [selectedExpCurrenciesFilter, setSelectedExpCurrenciesFilter] = useState([]);
  const [isExpCurrencyFilterDropdownOpen, setIsExpCurrencyFilterDropdownOpen] = useState(false);
  const [isExpCurrencyFilterModalDropdownOpen, setIsExpCurrencyFilterModalDropdownOpen] = useState(false);
  const [expCurrencyDropdownSearchTerm, setExpCurrencyDropdownSearchTerm] = useState('');
  const [selectedExpStatusFilter, setSelectedExpStatusFilter] = useState([]);
  const [isExpStatusFilterDropdownOpen, setIsExpStatusFilterDropdownOpen] = useState(false);
  const [expStatusDropdownSearchTerm, setExpStatusDropdownSearchTerm] = useState("");
  const [selectAllExpStatusFilter, setSelectAllExpStatusFilter] = useState(false);
  const teamDropdownRef = useRef(null);
  const teamModalDropdownRef = useRef(null);
  const clientDropdownRef = useRef(null);
  const clientModalDropdownRef = useRef(null);
  const projectDropdownRef = useRef(null);
  const projectModalDropdownRef = useRef(null);
  const deptDropdownRef = useRef(null);
  const deptModalDropdownRef = useRef(null);
  const expCategoryDropdownRef = useRef(null);
  const expCategoryModalDropdownRef = useRef(null);
  const expCurrencyFilterDropdownRef = useRef(null);
  const expStatusFilterDropdownRef = useRef(null);
  const expCurrencyFilterModalDropdownRef = useRef(null);
  const expenseDateRef = useRef(null);
  const expenseDescriptionRef = useRef(null);
  const expenseCategoryRef = useRef(null);
  const expenseCurrencyRef = useRef(null);
  const expSubTotalRef = useRef(null);
  const expTaxRef = useRef(null);
  const expCurrencyDropdownRef = useRef(null);
  const expenseUserRef = useRef(null);
  const expenseUserSelectDropdownRef = useRef(null);
  const expenseClientRef = useRef(null);
  const expenseClientDropdownRef = useRef(null);
  const expenseProjectRef = useRef(null);
  const expenseProjectDropdownRef = useRef(null);
  const expenseCompanyRef = useRef(null);
  const expenseCompanyDropdownRef = useRef(null);
  const expenseCategoryDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const calendarRef = useRef(null);
  const calendarModalRef = useRef(null);
  const expFileAttchRef = useRef(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const { appSettings } = useSelector((state) => state.appSettings);
  const token = useSelector(
    (state) => state.auth.token
  )

  const { data: teams = [], isLoading: teamLoading, isError: teamError } = useGetTeams(token);
  const { data: activeTeams = [], isLoading: activeTeamLoading, isError: activeTeamError } = useGetActiveTeams(token);
  const { data: clients = [], isLoading: clientLoading, isError: clientError } = useGetExpenseClients(token);
  const { data: projects = [], isLoading: projectLoading, isError: projectError } = useGetProjects(token);
  const { data: wXCompany = [], isLoading: WXCompaniesLoading, isError: WXCompaniesError } = useWXCompanies();
  const { data: departments = [], isLoading: departmentLoading, isError: departmentError } = useGetExpenceDepartments();
  const { data: expenseId = [], isLoading: isLoadingExpenseId, refetch: refetchExpenseId } = useExpenseId(token);
  const { data: expenseCategory = [], isLoading: isLoadingExpCategory } = useFetchExpCategory(token);
  const { data: expenseDatas = [], isLoading: expenseLoading, refetch: refetchExpenseData } = useGetExpenseData(
    token,
    expenseData,
    dateRange && dateRange[0] || startOfYear,
    dateRange && dateRange[1] || endOfToday,
  );
  const selectAllRef = useRef();
  // const expenseDataa = useSelector((state) => state.expenseData.expenseDataState);

  const filteredExpStatusList = expenseStatusList.filter(status =>
    status.label.toLowerCase().includes(expStatusDropdownSearchTerm.toLowerCase())
  );


  const handleCheckboxTeamChange = (teamId) => {
    const updatedSelection = [...selectedTeams];
    const index = updatedSelection.indexOf(teamId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(teamId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedTeams(updatedSelection);
  };

  const handleSelectAllTeamChange = () => {
    if (!selectAllTeam) {
      setSelectedTeams(teams.map((team) => team._id));
    } else {
      setSelectedTeams([]);
    }
    setSelectAllTeam(!selectAllTeam);
  };

  const filteredDropdownUsers = teams.filter((user) => {
    const fullName = user.first_name
      ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
      : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
    return fullName.toLowerCase().includes(userDropdownSearchTerm.toLowerCase());
  });

  const handleUserDropdownSearchChange = (e) => {
    setUserDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    const handleLoading = async () => {
      await dispatch(setAppLoading(expenseLoading));
    };
    handleLoading();
  }, [expenseLoading]);

  useEffect(() => {
    // Introduce a slight delay to avoid blocking the main thread
    const timer = setTimeout(() => {
      const isAllTeamsSelected = selectedTeams.length === teams.length;

      setSelectAllTeam(isAllTeamsSelected);

      if (isAllTeamsSelected) {
        selectTeam(null); // Clear selection
      } else {
        selectTeam(selectedTeams); // Update selected teams
      }
    }, 100); // Small delay (100ms)

    // Cleanup function to avoid overlapping timers
    return () => clearTimeout(timer);
  }, [selectedTeams, teams]);


  const toggleTeamDropdown = () => {
    setIsTeamDropdownOpen(!isTeamDropdownOpen);
    setUserDropdownSearchTerm("");
  };

  const toggleTeamModalDropdown = () => {
    setIsTeamModalDropdownOpen(!isTeamModalDropdownOpen);
    setUserDropdownSearchTerm("");
  };

  const handleCheckboxClientChange = (clientId) => {
    const updatedSelection = [...selectedClients];
    const index = updatedSelection.indexOf(clientId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(clientId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedClients(updatedSelection);
  };

  const handleSelectAllClientChange = () => {
    if (!selectAllClient) {
      setSelectedClients(clients.map((client) => client._id));
    } else {
      setSelectedClients([]);
    }
    setSelectAllClient(!selectAllClient);
  };

  const filteredDropdownClients = clients.filter((client) => {
    const clientName = client.client_name || client.legal_entity_name;
    return clientName.toLowerCase().includes(clientDropdownSearchTerm.toLowerCase());
  });

  const handleClientDropdownSearchChange = (e) => {
    setClientDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Non-blocking with slight delay
    const timer = setTimeout(() => {
      const isAllClientsSelected = selectedClients.length === clients.length;

      setSelectAllClient(isAllClientsSelected);
      selectClient(isAllClientsSelected ? null : selectedClients);
    }, 100); // Small delay (100ms)

    // Cleanup timer on dependency change
    return () => clearTimeout(timer);
  }, [selectedClients, clients]);

  const toggleClientDropdown = () => {
    setIsClientDropdownOpen(!isClientDropdownOpen);
    setClientDropdownSearchTerm("");
  };

  const toggleClientModalDropdown = () => {
    setIsClientModalDropdownOpen(!isClientModalDropdownOpen);
    setClientDropdownSearchTerm("");
  };

  const handleCheckboxProjectChange = (projectId) => {
    const updatedSelection = [...selectedProjects];
    const index = updatedSelection.indexOf(projectId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(projectId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedProjects(updatedSelection);
  };

  const handleSelectAllProjectChange = () => {
    if (!selectAllProject) {
      setSelectedProjects(projects.map((project) => project._id));
    } else {
      setSelectedProjects([]);
    }
    setSelectAllProject(!selectAllProject);
  };

  useEffect(() => {
    // Introduce non-blocking logic with a slight debounce
    const timer = setTimeout(() => {
      const isAllProjectsSelected = selectedProjects.length === projects.length;

      // Update the project selection conditionally
      selectProject(isAllProjectsSelected ? null : selectedProjects);
    }, 100); // Add a delay of 100ms to prevent blocking

    // Cleanup the timer when dependencies change
    return () => clearTimeout(timer);
  }, [selectedProjects, projects]);

  const toggleProjectDropdown = () => {
    setIsProjectDropdownOpen(!isProjectDropdownOpen);
  };

  const toggleProjectModalDropdown = () => {
    setIsProjectModalDropdownOpen(!isProjectModalDropdownOpen);
  };

  const handleCheckboxDeptChange = (deptId) => {
    const updatedSelection = [...selectedDepts];
    const index = updatedSelection.indexOf(deptId);

    if (index === -1) {
      // Add to selection
      updatedSelection.push(deptId);
    } else {
      // Remove from selection
      updatedSelection.splice(index, 1);
    }

    setSelectedDepts(updatedSelection);
  };

  const handleSelectAllDeptChange = () => {
    if (!selectAllDept) {
      setSelectedDepts(departments.map((dept) => dept._id));
    } else {
      setSelectedDepts([]);
    }
    setSelectAllDept(!selectAllDept);
  };

  const filteredDropdownDepartments = departments.filter((department) => {
    return department?.user_department?.toLowerCase().includes(departmentDropdownSearchTerm.toLowerCase());
  });

  const handleDepartmentDropdownSearchChange = (e) => {
    setDepartmentDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Introduce non-blocking logic with a slight debounce
    const timer = setTimeout(() => {
      const isAllDeptsSelected = selectedDepts.length === departments.length;

      // Update department selection conditionally
      setSelectAllDept(isAllDeptsSelected);
      selectDepartment(isAllDeptsSelected ? null : selectedDepts);
    }, 100); // Add a delay of 100ms to prevent blocking

    // Cleanup the timer when dependencies change
    return () => clearTimeout(timer);
  }, [selectedDepts, departments]);

  const toggleDeptDropdown = () => {
    setIsDeptDropdownOpen(!isDeptDropdownOpen);
    setDepartmentDropdownSearchTerm("");
  };

  const toggleDeptModalDropdown = () => {
    setIsDeptModalDropdownOpen(!isDeptModalDropdownOpen);
    setDepartmentDropdownSearchTerm("");
  };

  const handleCheckboxExpCategoryChange = (expCategoryId) => {
    const updatedSelection = [...selectedExpCategories];
    const index = updatedSelection.indexOf(expCategoryId);

    if (index === -1) {
      updatedSelection.push(expCategoryId);
    } else {
      updatedSelection.splice(index, 1);
    }

    setSelectedExpCategories(updatedSelection);
  };

  const handleSelectAllExpCategoryChange = () => {
    if (!selectAllExpCategory) {
      setSelectedExpCategories(expenseCategory.map((expCat) => expCat._id));
    } else {
      setSelectedExpCategories([]);
    }
    setSelectAllExpCategory(!selectAllExpCategory);
  };

  const filteredDropdownExpenseCategory = expenseCategory.filter((expCat) => {
    return expCat?.exp_category_name?.toLowerCase().includes(categoryDropdownSearchTerm.toLowerCase());
  });

  const handleCategoryDropdownSearchChange = (e) => {
    setCategoryDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Add a non-blocking delay with debounce logic
    const timer = setTimeout(() => {
      const isAllExpCategoriesSelected =
        selectedExpCategories.length === expenseCategory.length;

      // Update the selection only when necessary
      setSelectAllExpCategory(isAllExpCategoriesSelected);
      selectExpCategory(isAllExpCategoriesSelected ? null : selectedExpCategories);
    }, 100); // Adjust the debounce delay as needed

    // Cleanup the timer when dependencies change
    return () => clearTimeout(timer);
  }, [selectedExpCategories, expenseCategory]);

  const toggleExpCategoryDropdown = () => {
    setIsExpCategoryDropdownOpen(!isExpCategoryDropdownOpen);
    setCategoryDropdownSearchTerm("");
  };

  const toggleExpCategoryModalDropdown = () => {
    setIsExpCategoryModalDropdownOpen(!isExpCategoryModalDropdownOpen);
    setCategoryDropdownSearchTerm("");
  };

  const handleCheckboxExpCurrencyFilterChange = (expCurrencyFilterId) => {
    const updatedSelection = [...selectedExpCurrenciesFilter];
    const index = updatedSelection.indexOf(expCurrencyFilterId);

    if (index === -1) {
      updatedSelection.push(expCurrencyFilterId);
    } else {
      updatedSelection.splice(index, 1);
    }

    setSelectedExpCurrenciesFilter(updatedSelection);
  };

  const handleSelectAllExpCurrencyFilterChange = () => {
    if (!selectAllExpCurrencyFilter) {
      setSelectedExpCurrenciesFilter(expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    } else {
      setSelectedExpCurrenciesFilter([]);
    }
    setSelectAllExpCurrencyFilter(!selectAllExpCurrencyFilter);
  };

  const filteredDropdownExpCurrencyList = expCurrencyList.filter((expCurrency) =>
    `${expCurrency.currencyCode} (${expCurrency.currencyName})`
      .toLowerCase()
      .includes(expCurrencyDropdownSearchTerm.toLowerCase())
  );

  const handleExpCurrencyDropdownSearchChange = (e) => {
    setExpCurrencyDropdownSearchTerm(e.target.value);
  };

  useEffect(() => {
    // Add a non-blocking delay with debounce logic
    const timer = setTimeout(() => {
      const isAllExpCurrenciesSelected =
        selectedExpCurrenciesFilter.length === expCurrencyList.length;

      // Update the state and selection only when necessary
      setSelectAllExpCurrencyFilter(isAllExpCurrenciesSelected);
      selectExpCurrencyFilter(isAllExpCurrenciesSelected ? null : selectedExpCurrenciesFilter);
    }, 100); // Adjust the debounce delay as needed

    // Cleanup the timer when dependencies change
    return () => clearTimeout(timer);
  }, [
    selectedExpCurrenciesFilter,
    expCurrencyList
  ]);

  const toggleExpCurrencyFilterDropdown = () => {
    setIsExpCurrencyFilterDropdownOpen(!isExpCurrencyFilterDropdownOpen);
    setExpCurrencyDropdownSearchTerm("");
  };

  const toggleExpCurrencyFilterModalDropdown = () => {
    setIsExpCurrencyFilterModalDropdownOpen(!isExpCurrencyFilterModalDropdownOpen);
    setExpCurrencyDropdownSearchTerm("");
  };

  const toggleExpStatusFilterDropdown = () => {
    setIsExpStatusFilterDropdownOpen(!isExpStatusFilterDropdownOpen);
  };

  const handleExpStatusDropdownSearchChange = (e) => {
    setExpStatusDropdownSearchTerm(e.target.value);
  };

  const handleSelectAllExpStatusFilterChange = () => {
    if (selectAllExpStatusFilter) {
      setSelectedExpStatusFilter([]);
    } else {
      setSelectedExpStatusFilter(expenseStatusList.map((s) => s.value));
    }
    setSelectAllExpStatusFilter(!selectAllExpStatusFilter);
  };

  const handleCheckboxExpStatusFilterChange = (value) => {
    setSelectedExpStatusFilter((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      const isAllExpStatusSelected = selectedExpStatusFilter.length === expenseStatusList.length;
      setSelectAllExpStatusFilter(isAllExpStatusSelected);
      // selectExpStatusFilter(isAllExpStatusSelected ? null : selectedExpStatusFilter);
      selectExpStatusFilter(selectedExpStatusFilter);
    }, 100);

    return () => clearTimeout(timer);
  }, [selectedExpStatusFilter, expenseStatusList]);

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideShowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);
    const isClickInsideTeamDropdown = teamDropdownRef.current && teamDropdownRef.current.contains(event.target);
    const isClickInsideTeamModalDropdown = teamModalDropdownRef.current && teamModalDropdownRef.current.contains(event.target);
    const isClickInsideClientDropdown = clientDropdownRef.current && clientDropdownRef.current.contains(event.target);
    const isClickInsideClientModalDropdown = clientModalDropdownRef.current && clientModalDropdownRef.current.contains(event.target);
    const isClickInsideProjectDropdown = projectDropdownRef.current && projectDropdownRef.current.contains(event.target);
    const isClickInsideProjectModalDropdown = projectModalDropdownRef.current && projectModalDropdownRef.current.contains(event.target);
    const isClickInsideDeptDropdown = deptDropdownRef.current && deptDropdownRef.current.contains(event.target);
    const isClickInsideDeptModalDropdown = deptModalDropdownRef.current && deptModalDropdownRef.current.contains(event.target);
    const isClickInsideExpCategoryDropdown = expCategoryDropdownRef.current && expCategoryDropdownRef.current.contains(event.target);
    const isClickInsideExpCategoryModalDropdown = expCategoryModalDropdownRef.current && expCategoryModalDropdownRef.current.contains(event.target);
    const isClickInsideExpCurrencyFilterDropdown = expCurrencyFilterDropdownRef.current && expCurrencyFilterDropdownRef.current.contains(event.target);
    const isClickInsideExpCurrencyFilterModalDropdown = expCurrencyFilterModalDropdownRef.current && expCurrencyFilterModalDropdownRef.current.contains(event.target);
    const isClickInsideExpCurrencyDropdown = expCurrencyDropdownRef.current && expCurrencyDropdownRef.current.contains(event.target);
    const isClickInsideExpenseUserDropdown = expenseUserSelectDropdownRef.current && expenseUserSelectDropdownRef.current.contains(event.target);
    const isClickInsideExpClientDropdown = expenseClientDropdownRef.current && expenseClientDropdownRef.current.contains(event.target);
    const isClickInsideExpProjectDropdown = expenseProjectDropdownRef.current && expenseProjectDropdownRef.current.contains(event.target);
    const isClickInsideExpCompanyDropdown = expenseCompanyDropdownRef.current && expenseCompanyDropdownRef.current.contains(event.target);
    const isClickInsideExpenseCategoryDropdown = expenseCategoryDropdownRef.current && expenseCategoryDropdownRef.current.contains(event.target);
    const isClickInsideCalendarDropdown = calendarRef.current && calendarRef.current.contains(event.target);
    const isClickInsideModalCalendarDropdown = calendarModalRef.current && calendarModalRef.current.contains(event.target);

    if (!isClickInsideShowingDropdown) {
      setShowingDropdownOpen(false);
    }
    if (!isClickInsideTeamDropdown) {
      setIsTeamDropdownOpen(false);
    }
    if (!isClickInsideTeamModalDropdown) {
      setIsTeamModalDropdownOpen(false);
    }
    if (!isClickInsideClientDropdown) {
      setIsClientDropdownOpen(false);
    }
    if (!isClickInsideClientModalDropdown) {
      setIsClientModalDropdownOpen(false);
    }
    if (!isClickInsideProjectDropdown) {
      setIsProjectDropdownOpen(false);
    }
    if (!isClickInsideProjectModalDropdown) {
      setIsProjectModalDropdownOpen(false);
    }
    if (!isClickInsideDeptDropdown) {
      setIsDeptDropdownOpen(false);
    }
    if (!isClickInsideDeptModalDropdown) {
      setIsDeptModalDropdownOpen(false);
    }
    if (!isClickInsideExpCategoryDropdown) {
      setIsExpCategoryDropdownOpen(false);
    }
    if (!isClickInsideExpCategoryModalDropdown) {
      setIsExpCategoryModalDropdownOpen(false);
    }
    if (!isClickInsideExpCurrencyFilterDropdown) {
      setIsExpCurrencyFilterDropdownOpen(false);
    }
    if (!isClickInsideExpCurrencyFilterModalDropdown) {
      setIsExpCurrencyFilterModalDropdownOpen(false);
    }
    if (!isClickInsideShowingDropdown) {
      setShowingDropdownOpen(false);
    }
    if (!isClickInsideExpCurrencyDropdown) {
      setExpCurrencyDropdownOpen(false);
    }
    if (!isClickInsideExpenseUserDropdown) {
      setExpenseUserDropdownOpen(false);
    }
    if (!isClickInsideExpClientDropdown) {
      setExpClientDropdownOpen(false);
    }
    if (!isClickInsideExpProjectDropdown) {
      setExpProjectDropdownOpen(false);
    }
    if (!isClickInsideExpCompanyDropdown) {
      setExpCompanyDropdownOpen(false);
    }
    if (!isClickInsideExpenseCategoryDropdown) {
      setExpenseCategoryDropdownOpen(false);
    }
    if (!isClickInsideCalendarDropdown) {
      setShowCalendar(false);
    }
    if (!isClickInsideModalCalendarDropdown) {
      setShowModalCalendar(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);

    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  const queryClient = useQueryClient();

  const user = useSelector(
    (state) => state.auth.user
  )

  const selectInitialTeam = () => {
    if (user && user._id && (user.userType === userTypeConsts.PROJECT_MANAGER || user.userType === userTypeConsts.TEAM_MANAGER)) {
      const projectManagerTeamId = user._id;
      selectTeam([projectManagerTeamId]);
    }
  };

  useEffect(() => {
    setExpCurrencyList(Currencies.sourceCurrencies[0].targetCurrencies);
    setSelectedTeams(teams.map((team) => team._id));
    setSelectedClients(clients.map((client) => client._id));
    setSelectedProjects(projects.map((project) => project._id));
    setSelectedDepts(departments.map((dept) => dept._id));
    setSelectedExpCategories(expenseCategory && expenseCategory.map((expCat) => expCat._id));
    setSelectedExpCurrenciesFilter(expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    setSelectedExpStatusFilter(expenseStatusList.map((expStatus) => expStatus.value));
  }, [teams, clients, projects, departments, expenseCategory, expCurrencyList, expenseStatusList]);

  const selectTeam = async (team) => {
    await dispatch(setExpTeam(team));
  }
  const selectClient = async (client) => {
    await dispatch(setExpClient(client));
  }
  const selectProject = async (project) => {
    await dispatch(setExpProject(project));
  }
  const selectDepartment = async (department) => {
    await dispatch(setExpDepartment(department));
  }

  const selectExpCategory = async (selExpCategory) => {
    await dispatch(setFilterExpCategory(selExpCategory));
  }

  const selectExpCurrencyFilter = async (selExpCurrency) => {
    await dispatch(setFilterExpCurrency(selExpCurrency));
  }

  const selectExpStatusFilter = async (selExpStatus) => {
    await dispatch(setFilterExpStatus(selExpStatus));
  }

  const selectDate = (date) => {
    if (date) {
      setDates(new Date(date));
    } else {
      setDates(null);
    }
  }

  const handleSelect = (ranges) => {
    setDateRange(ranges);
    if (ranges === null) {
      const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
      setDateRange(null);
    }
  };

  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const toggleFilterModal = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(!showFilterModal);
  };

  const clearFilters = () => {
    setSelectedTeams(teams.map((team) => team._id));
    setSelectedClients(clients.map((client) => client._id));
    setSelectedProjects(projects.map((project) => project._id));
    setSelectedDepts(departments.map((dept) => dept._id));
    setSelectedExpCategories(expenseCategory.map((expCat) => expCat._id));
    setSelectedExpCurrenciesFilter(expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    setDateRange([startOfYear, endOfToday]);
    setShowFilterModal(false);
  };

  const checkAndShowConfirmationModal = () => {
    const isTeamsModified = !isEqual(selectedTeams, teams.map((team) => team._id));
    const isClientsModified = !isEqual(selectedClients, clients.map((client) => client._id));
    const isProjectsModified = !isEqual(selectedProjects, projects.map((project) => project._id));
    const isDeptsModified = !isEqual(selectedDepts, departments.map((dept) => dept._id));
    const isExpCategoriesModified = !isEqual(selectedExpCategories, expenseCategory.map((expCat) => expCat._id));
    const isExpCurrenciesFilterModified = !isEqual(selectedExpCurrenciesFilter, expCurrencyList.map((expCurrency) => expCurrency.currencyCode));
    const isDateRangeModified = !isEqual(dateRange, [startOfYear, endOfToday]);

    if (
      isTeamsModified ||
      isClientsModified ||
      isProjectsModified ||
      isDeptsModified ||
      isExpCategoriesModified ||
      isExpCurrenciesFilterModified ||
      isDateRangeModified
    ) {
      setShowConfirmationModal(true);
    } else {
      setShowFilterModal(false);
    }
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
  };

  const handleApplyConfirm = () => {
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const disableInput = (event) => {
    event.preventDefault();
  };

  const totalResults = expenseDatas.length;

  const handleOpenCreateModal = () => {
    setIsCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    refetchExpenseId();
    setExpDescription("");
    setExpenseDate(null);
    setExpCategory("");
    setExpCurrency("");
    setExpSubTotal("");
    setExpTax("");
    setExpAmount("");
    setExpIsBillable(true);
    setExpenseUser("");
    setExpenseClient("");
    setExpenseProject("");
    setExpenseCompany("");
    setExpNote("");
    setExpFileAttchFiles([]);
    setExpFileAttchFileName("");
    setExpenseDateIsValid(false);
    setExpenseCategoryIsValid(false);
    setExpenseCurrencyIsValid(false);
    setExpenseUserIsValid(false);
    setExpenseClientIsValid(false);
    setExpenseCompanyIsValid(false);
    setIsCreateModalOpen(false);
  };

  const handleDateChange = (date) => {
    setExpenseDate(date);
  };

  const disabledDate = date => {
    return date > new Date();
  };

  const handleToggleExpCurrencyDropdown = () => {
    setExpCurrencySearchTerm('');
    setExpCurrencyDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleExpCurrencySearchInputChange = (e) => {
    setExpCurrencySearchTerm(e.target.value);
  };

  const filteredExpCurrencies = expCurrencyList.filter((expCurrency) => {
    const expCurrencyName = expCurrency.currencyCode
      && `${expCurrency.currencyCode} (${expCurrency.currencyName})`;
    return expCurrencyName?.toLowerCase().includes(expCurrencySearchTerm?.toLowerCase());
  });

  const handleToggleExpenseUserDropdown = () => {
    setUserSearchTerm('');
    setExpenseUserDropdownOpen((prevOpen) => !prevOpen);
  };

  const handleSelectExpenseUser = (selectedExpenseUser) => {
    setExpenseUser(selectedExpenseUser);
    setUserSearchTerm('');
    setExpenseUserDropdownOpen(false);
  };

  const handleExpenseUserSearchInputChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  const filteredUsers = activeTeams.filter((user) => {
    const fullName = user.first_name
      ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
      : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
    return fullName?.toLowerCase().includes(userSearchTerm?.toLowerCase());
  });

  const handleToggleExpClientDropdown = () => {
    setExpClientSearchTerm('');
    setExpClientDropdownOpen(!expClientDropdownOpen);
  };

  const handleExpClientSearchInputChange = (e) => {
    setExpClientSearchTerm(e.target.value);
  };

  const filteredClients = clients && clients
    .filter((expClient) =>
      expClient.client_name?.toLowerCase().includes(expClientSearchTerm && expClientSearchTerm?.toLowerCase())
    )
    .sort((a, b) =>
      a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
    );

  const handleToggleExpProjectDropdown = () => {
    setExpProjectSearchTerm('');
    setExpProjectDropdownOpen(!expProjectDropdownOpen);
  };

  const handleExpProjectSearchInputChange = (e) => {
    setExpProjectSearchTerm(e.target.value);
  };

  const filteredProjects = projects && projects
    .filter((expProject) =>
      expProject.client_name?._id === expenseClient &&
      expProject?.project_name?.toLowerCase().includes(expProjectSearchTerm && expProjectSearchTerm?.toLowerCase())
    )
    .sort((a, b) =>
      a.project_name?.toLowerCase().localeCompare(b.project_name?.toLowerCase())
    );

  const handleToggleExpCompanyDropdown = () => {
    setExpCompanySearchTerm('');
    setExpCompanyDropdownOpen(!expCompanyDropdownOpen);
  };

  const handleExpCompanySearchInputChange = (e) => {
    setExpCompanySearchTerm(e.target.value);
  };

  const filteredCompany = wXCompany && wXCompany
    .filter((expCompany) =>
      expCompany.wx_company?.toLowerCase().includes(expCompanySearchTerm && expCompanySearchTerm?.toLowerCase())
    )
    .sort((a, b) =>
      a.wx_company?.toLowerCase().localeCompare(b.wx_company?.toLowerCase())
    );


  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv", "jpeg", "jpg", "png", "gif"];

  const handleExpFileAttchFileUpload = (event) => {
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 0) {
      if (selectedFiles.length + expFileAttchFiles.length > 10) {
        // Display toast error message when the total number of files exceeds 10
        toast.error('Maximum of 10 files can be uploaded!', {
          position: 'bottom-right',
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }
      const newFiles = Array.from(selectedFiles);

      // Validate file extensions and update state
      const validFiles = newFiles.filter((file) => {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          return true;
        } else {
          toast.error(`Invalid file format for ${file.name}. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!`, {
            position: 'bottom-right',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return false;
        }
      });

      // Update the state with the valid files
      setExpFileAttchFiles((prevFiles) => [...prevFiles, ...validFiles]);

      // Clear the file input for multiple selections
      expFileAttchRef.current.value = '';
    }
  };

  const removeFile = (index) => {
    // Remove the file at the specified index
    setExpFileAttchFiles((prevFiles) => {
      const updatedFiles = [...prevFiles];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };
  const exportToExcel = () => {
    if (expenseDatas.length === 0) {
      toast.error("No data to export.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const baseUrl = `${window.location.protocol}//${window.location.host}`;

      const modifiedLog = expenseDatas.map((item, index) => ({
        "Sl No": index + 1,
        "Expense ID": item.exp_id,
        "User": item.exp_user
          ? item.exp_user.first_name
            ? `${item.exp_user.first_name} ${item.exp_user.middle_name ? item.exp_user.middle_name : ''} ${item.exp_user.last_name ? item.exp_user.last_name : ''}`
            : item.exp_user.company_first_name
              ? `${item.exp_user.company_first_name} ${item.exp_user.company_last_name ? item.exp_user.company_last_name : ''}`
              : item.exp_user.company_name
          : '',
        "Date": moment(item.exp_date)
          .tz(global.config.getTimeZone())
          .format("DD/MM/YYYY"),
        "Category": item.exp_category
          ? item.exp_category.exp_category_name
          : '',
        "Amount": item.exp_amount.toLocaleString("en-US", {
          style: "currency",
          currency: item.exp_currency,
        }),
        "Billable": item.exp_is_billable === true ? "Yes" : "No",
        "Client": item.exp_client
          ? item.exp_client.client_name || item.exp_client.legal_entity_name
          : '',
        "Project": item.exp_project
          ? item.exp_project.project_name
          : '',
        "Company": item.exp_company
          ? item.exp_company.wx_company || item.exp_company.legal_entity_company_name
          : '',
        "Sub Total": item.exp_sub_total ? item.exp_sub_total.toFixed(2) : "0.00",
        "Tax": item.exp_tax ? item.exp_tax.toFixed(2) : "0.00",
        "Amount": item.exp_amount.toLocaleString("en-US", {
          style: "currency",
          currency: item.exp_currency,
        }),
        "PDF URL": item.exp_file_attch && item.exp_file_attch.length > 0
          ? item.exp_file_attch
            .map(file => `${baseUrl}/uploads/expense/document/${file}`)
            .join(" ,\n")
          : '',
        "Notes": item.exp_note || '',
        "Created At": moment(item.created_at).tz(global.config.getTimeZone()).format("DD/MM/YYYY, hh:mm:ss A"),
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 25 },
        { wpx: 75 },
        { wpx: 175 },
        { wpx: 110 },
        { wpx: 120 },
        { wpx: 110 },
        { wpx: 80 },
        { wpx: 120 },
        { wpx: 80 },
        { wpx: 80 },
        { wpx: 500 },
        { wpx: 180 },
        { wpx: 150 },
      ];
      worksheet["!cols"] = colWidths;
      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center !important";
        style.alignment.vertical = "center !important";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }
      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }
      global.config.activityLog(
        window.location.href,
        "Expense",
        "Expense Data exported to Excel"
      );
      const fileName = `Expenses_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "Expenses");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "Expenses",
        "Error occurred while exporting Expenses datas to Excel"
      );
      alert("Error occurred while exporting Expenses datas to Excel.");
    }
  };

  const handleExpenseCategory = (event) => {
    navigate("../expense-category");
  };

  const calculateAmount = (expSubTotal, expTax) => {
    const subTotalAmount = expSubTotal ? parseFloat(expSubTotal) : 0;
    const taxPercentage = expTax ? parseFloat(expTax) : 0;

    if (!isNaN(subTotalAmount) && !isNaN(taxPercentage)) {
      const taxAmount = (subTotalAmount * taxPercentage) / 100;
      return subTotalAmount + taxAmount;
    } else {
      return '';
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setExpenseCategoryIsValid(false);
    setExpenseCurrencyIsValid(false);
    setExpenseDateIsValid(false);
    setExpenseUserIsValid(false);
    setExpenseClientIsValid(false);
    setExpenseCompanyIsValid(false);
    if (
      expenseId === "" ||
      expDescription === "" ||
      expenseDate === null ||
      expCategory === "" ||
      expCurrency === "" ||
      expSubTotal === "" ||
      expTax === "" ||
      expenseUser === "" ||
      (expIsBillable && expenseClient === "" ? true : false) ||
      (!expIsBillable && expenseCompany === "" ? true : false)
    ) {
      if (expenseDate === null) {
        setExpenseDateIsValid(true);
        expenseDateRef && expenseDateRef.current && expenseDateRef.current.focus();
        toast.error("Expense date cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expDescription === "") {
        setExpenseDescriptionIsValid(true);
        expenseDescriptionRef && expenseDescriptionRef.current.focus();
        toast.error("Expense description cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expCategory === "") {
        setExpenseCategoryIsValid(true);
        expenseCategoryRef && expenseCategoryRef.current.focus();
        toast.error("Expense category cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expCurrency === "") {
        setExpenseCurrencyIsValid(true);
        expenseCurrencyRef && expenseCurrencyRef.current.focus();
        toast.error("Expense currency cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expSubTotal === "") {
        setExpSubTotalIsValid(true);
        expSubTotalRef && expSubTotalRef.current.focus();
        toast.error("Expense sub total cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expTax === "") {
        setExpTaxIsValid(true);
        expTaxRef && expTaxRef.current.focus();
        toast.error("Expense Tax cannot be empty!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expenseUser === "") {
        setExpenseUserIsValid(true);
        expenseUserRef && expenseUserRef.current.focus();
        toast.error("User has to be seleted!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (expIsBillable && expenseClient === "") {
        setExpenseClientIsValid(true);
        expenseClientRef && expenseClientRef.current.focus();
        toast.error("Client has to be seleted!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      } else if (!expIsBillable && expenseCompany === "") {
        setExpenseCompanyIsValid(true);
        expenseCompanyRef && expenseCompanyRef.current.focus();
        toast.error("Company has to be seleted!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return;
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    const requestData = {
      exp_id: expenseId,
      exp_description: expDescription,
      exp_date: expenseDate,
      exp_category: expCategory,
      exp_currency: expCurrency,
      exp_sub_total: expSubTotal,
      exp_tax: expTax,
      exp_amount: expAmount,
      exp_is_billable: expIsBillable,
      exp_user: expenseUser,
      exp_clientValue: expIsBillable ? expenseClient : null,
      exp_projectValue: (expIsBillable && expenseClient) ? expenseProject : null,
      exp_CompanyValue: !expIsBillable ? expenseCompany : null,
      exp_note: expNote,
    };

    const formData = new FormData();
    for (let i = 0; i < expFileAttchFiles.length; i++) {
      formData.append("exp_file_attch", expFileAttchFiles[i]);
    }
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }
    try {
      setIsSubmitLoading(true);
      const response = await axios.post("/api/expense/create", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success("Expense data created successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(setNotification(Date.now()));
        handleCloseCreateModal();
        global.config.activityLog(window.location.href, 'Expense', `Expense, (${expenseId}) data created Successfully`);
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      alert("Something went wrong");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const expenseSubmit = async () => {
    var autoData = [];
    if (expenseDate === null) {
      setExpenseDateIsValid(true);
      expenseDateRef && expenseDateRef.current && expenseDateRef.current.focus();
      toast.error("Expense date cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else if (expCategory === "") {
      setExpenseCategoryIsValid(true);
      expenseCategoryRef && expenseCategoryRef.current.focus();
      toast.error("Expense category cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else if (expCurrency === "") {
      setExpenseCurrencyIsValid(true);
      expenseCurrencyRef && expenseCurrencyRef.current.focus();
      toast.error("Expense currency cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    } else {
      autoData.push(expenseDate);
      autoData.push(expCategory);
      autoData.push(expCurrency);
      await dispatch(setExpenseData(autoData));
      navigate("/user/expense/create");
    }
  };

  const onDateChange = (ranges) => {

    const startOfDayUTC = moment(ranges.startDate).startOf("day").toDate();
    const endOfDayUTC = moment(ranges.endDate).endOf("day").toDate();
    const dateRangeArray = [startOfDayUTC, endOfDayUTC];

    setDateRange(dateRangeArray);
    setShowCalendar(false);
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const cancelCalendar = () => {
    setShowCalendar(false);
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      border: '0.2px solid rgba(106, 121, 136, 0.7)',
      borderRadius: '10px',
      padding: '8px 16px',
      fontSize: '17px',
      width: '251px',
      color: '#78828D',
      height: '43px',
      padding: '0px',
      cursor: 'pointer',
      textAlign: 'left',
      fontWeight: 300,
      lineHeight: '21px',
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '8px 16px',
      color: state.isSelected ? 'white' : '#78828D', // Change color for selected item
      backgroundColor: state.isSelected ? '#D1D8FF' : 'transparent', // Change background color for selected item
      fontWeight: 300,
      fontSize: '17px',
      lineHeight: '38px',
      textAlign: 'left',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0px 21px 0px 0px',
      color: state.isFocused ? '#405BFF' : '#405BFF',
    }),
    // Add more custom styles as needed
  };
  const [selDashboardCurrency, setSelDashboardCurrency] = useState("");

  const handleCurrencyChange = async (option) => {

    setSelectedCurrency(option.value);
    setSelDashboardCurrency(option.value);
    const forex = await getForex(option.value);
    setSelectedForex(forex);
    await dispatch(setForex(forex));
    await dispatch(setDashboardCurrencyRx(option.value));
    // Do something with the selected currency value, such as dispatching an action
  };

  const formatOptionLabel = ({ value, label }) => {
    const currencySymbol = label.substring(0, 1); // Extract the currency symbol
    const currencyText = label.substring(1); // Extract the remaining currency text
    return (
      <div className="currency-option">
        <span className="currency-symbol">{new Intl.NumberFormat('en-US', { style: 'currency', currency: value, }).format(0).replace(/[\d.,]/g, '')}</span>
        <span className="dropdown-text">{label}</span>
      </div>
    );
  };



  const [selectedForex, setSelectedForex] = useState([]);
  const getForex = async (currency) => {

    const response = await axios.post('/api/forex/get', { base_currency: "USD" }, {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });

    if (response.status === 200) {
      return response.data ? response.data.json : null;
    } else {
      console.error(`Request failed with status code: ${response.status}`);
    }

  }
  const { data: dashboardCurrency = [], isLoading: isLoadingFetchCurrency } = useFetchDashboardCurrency(user.token);
  const [allCurrency, setAllCurrency] = useState(false);

  const dashboradCurrency = useSelector((state) => state.invoice.dashboardCurrency);
  const dashboardCurrencySum = useSelector((state) => state.invoice.dashboardCurrencySum);
  const [selectedCurrency, setSelectedCurrency] = useState(dashboradCurrency);

  useEffect(() => {

    const ForexUpdate = async () => {
      const forex = await getForex('USD');
      setSelectedForex(forex);
      await dispatch(setForex(forex));
    }
    ForexUpdate();

    setSelectedCurrency(dashboradCurrency);
    const changeSumCur = async () => {
      await dispatch(setDashboardCurrencySum(dashboardCurrencySum));
    }
    setAllCurrency(dashboardCurrencySum);
    changeSumCur();

  }, [dashboardCurrencySum, dashboradCurrency]);

  useEffect(() => {
    dispatch(setDashboardCurrencyRx(global.config.appCurrency()));
  }, []);

  const sumAllCurrencies = async (val) => {
    setAllCurrency(val);
    setSelectedCurrency(global.config.appCurrency());
    await dispatch(setDashboardCurrencyRx(global.config.appCurrency()));
    await dispatch(setDashboardCurrencySum(val));
  }

  const getCur = expenseDatas.map((item) => {
    return item.exp_currency
  });
  const uniqueCurrencies = [...new Set(getCur)];
  const options = uniqueCurrencies.map((currency) => ({
    value: currency,
    label: `${getCurrencyByCode.code(currency).currency}`
  }));

  const toggleModalCalendar = () => {
    setShowModalCalendar(!showModalCalendar);
  };

  const cancelModalCalendar = () => {
    setShowModalCalendar(false);
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur()

    // Prevent the page/container scrolling
    e.stopPropagation()

    setTimeout(() => {
      e.target.focus()
    }, 0)
  }
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expStatusFilterDropdownRef.current &&
        !expStatusFilterDropdownRef.current.contains(event.target)
      ) {
        setIsExpStatusFilterDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [expStatusList, setExpStatusList] = useState([]);

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate =
        selectedExpStatusFilter.length > 0 && selectedExpStatusFilter.length < expStatusList.length;
    }
  }, [selectedExpStatusFilter, expStatusList]);

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.5 }}
    >
      <div className="overview-outer-time">
        <div className="overview-top">
          {/* Sum of all currencies module */}
          <div className="curency-dropdown curency-dropdown-expense manage-expense-outer">
            <div className="curency-dropdown-inner">
              <div className="currency-title"> {global.config.locate(appSettings && appSettings.language, 'Currency')}</div>
              {(selectedExpCurrenciesFilter && selectedExpCurrenciesFilter.length > 0) ?
                allCurrency === true ?
                  (
                    <Select
                      key={selectedCurrency}
                      defaultValue={{ value: selectedCurrency || "USD", label: getCurrencyByCode.code(selectedCurrency || "USD").currency }}
                      options={options}
                      styles={customStyles}
                      onChange={handleCurrencyChange}
                      formatOptionLabel={dashboradCurrency && formatOptionLabel}
                    />
                  ) : (
                    <Select
                      key={selectedCurrency}
                      defaultValue={{ value: selectedCurrency, label: getCurrencyByCode.code(selectedCurrency).currency }}
                      options={options}
                      styles={customStyles}
                      onChange={handleCurrencyChange}
                      formatOptionLabel={dashboradCurrency && formatOptionLabel}
                    />
                  ) : isLoadingFetchCurrency === true ?
                  (
                    <RotatingLines
                      strokeColor="grey"
                      strokeWidth="5"
                      animationDuration="0.75"
                      width="40"
                      visible={true}
                    />
                  ) :
                  global.config.locate(appSettings && appSettings.language, 'No Invoices Generated in this Account')
              }

              {(selectedExpCurrenciesFilter && selectedExpCurrenciesFilter.length > 0) &&
                <p>{global.config.locate(appSettings && appSettings.language, 'Sum all Currencies')}<input type="checkbox" checked={allCurrency} name="allCurrency" value={allCurrency} onChange={async (e) => {
                  sumAllCurrencies(!allCurrency); localStorage.setItem("allCur", !allCurrency);
                  const forex = await getForex(appSettings && appSettings.currency);
                  setSelectedForex(forex);
                  await dispatch(setForex(forex));
                  if (!allCurrency === true) {
                    await setDashboardCurrencyRx(global.config.appCurrency());
                    setSelectedCurrency(global.config.appCurrency());
                  }
                }} />
                </p>
              }
            </div>
            <div className="manage">
              <a onClick={handleExpenseCategory}>
                <span className="icon-invoice">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1143_332)">
                      <path d="M19.0704 7.87245C18.7124 7.87245 18.3983 7.6613 18.2626 7.33065L18.2304 7.25449C18.0947 6.92941 18.1709 6.55604 18.4255 6.30093C19.1789 5.54799 19.1733 4.32322 18.4255 3.57585L17.4281 2.57895C16.702 1.85263 15.4444 1.84768 14.7121 2.5678L14.7009 2.57895C14.4463 2.82786 14.0721 2.90402 13.7525 2.76842L13.6763 2.73622C13.3454 2.60619 13.1342 2.28607 13.1342 1.92879C13.1342 0.866873 12.2668 0 11.2044 0H9.78936C8.72688 0 7.85954 0.866873 7.85954 1.92879C7.85954 2.28669 7.64828 2.60619 7.32303 2.73622L7.25241 2.76842C6.92716 2.90402 6.55359 2.83344 6.29834 2.57895C5.545 1.83158 4.32516 1.83158 3.57182 2.57895L2.57438 3.57585C1.82104 4.32879 1.82104 5.54799 2.57438 6.3065C2.82901 6.56099 2.89963 6.92941 2.76396 7.26006L2.7367 7.33065C2.6066 7.6613 2.28631 7.87245 1.92884 7.87245C0.866357 7.87245 -0.000976562 8.73932 -0.000976562 9.80124V11.2099C-0.000976562 12.2774 0.866357 13.1387 1.91831 13.1387C2.27639 13.1387 2.59049 13.3498 2.72617 13.6749L2.75838 13.7511C2.89406 14.0762 2.81786 14.4495 2.56323 14.7046C1.81485 15.4576 1.81485 16.6824 2.56881 17.4297L3.57182 18.4266C4.32516 19.1746 5.545 19.1746 6.29834 18.4211C6.54739 18.1721 6.92158 18.096 7.24683 18.2316L7.31746 18.2638C7.64828 18.3938 7.85954 18.7139 7.85954 19.0712C7.85954 20.1331 8.72688 21 9.78936 21H11.2044C12.2668 21 13.1342 20.1387 13.1391 19.0656C13.1391 18.7077 13.3504 18.3938 13.6812 18.2582C13.6868 18.2582 13.7518 18.231 13.7518 18.231C14.0771 18.0954 14.4513 18.1715 14.7003 18.4204L14.7115 18.4316C15.4376 19.1523 16.7008 19.1467 17.4275 18.4204L18.4249 17.4235C19.1782 16.6762 19.1782 15.457 18.4249 14.6985C18.1759 14.4495 18.0996 14.0755 18.2353 13.7505L18.2626 13.6799C18.3983 13.3492 18.713 13.1381 19.0704 13.1381C20.1329 13.1381 21.0003 12.2712 21.0003 11.2093V9.80062C21.0003 8.7387 20.1329 7.87183 19.0704 7.87183V7.87245ZM19.965 11.2037C19.965 11.6861 19.5692 12.0817 19.0866 12.0817C18.2948 12.0817 17.596 12.5529 17.3029 13.2793L17.2757 13.3443C16.9721 14.065 17.1351 14.8885 17.6932 15.4464C18.0346 15.7932 18.0346 16.3461 17.6932 16.6873L16.6958 17.6842C16.3538 18.0254 15.7956 18.0254 15.4543 17.6842L15.4431 17.6731C14.8905 17.1257 14.0666 16.9684 13.351 17.2669L13.5517 17.7492L13.286 17.2885C12.5599 17.5814 12.0878 18.2805 12.0878 19.0712C12.0878 19.5536 11.6919 19.9492 11.2093 19.9492H9.79431C9.31171 19.9492 8.91583 19.5591 8.91583 19.0712C8.91583 18.2854 8.44995 17.587 7.72325 17.2941L7.6582 17.2669C7.41968 17.1641 7.16506 17.1152 6.91539 17.1152C6.41667 17.1152 5.92911 17.3158 5.57102 17.6842C5.22904 18.0254 4.67085 18.0254 4.32949 17.6842L3.33206 16.6873C2.99008 16.3461 2.99008 15.7882 3.33764 15.4415C3.89025 14.8892 4.05319 14.065 3.74962 13.3449L3.72236 13.2799C3.42437 12.5591 2.72493 12.0879 1.93875 12.0879C1.45614 12.0879 1.06027 11.6923 1.06027 11.2099V9.80124C1.06027 9.31889 1.45057 8.92322 1.93875 8.92322C2.72493 8.92322 3.42437 8.45201 3.72236 7.7257L3.74962 7.66625C4.05319 6.94551 3.89025 6.12198 3.33206 5.56409C2.9907 5.21734 2.9907 4.6644 3.33206 4.32322L4.32949 3.32632C4.67147 2.98514 5.22966 2.98514 5.57102 3.32632C6.12426 3.88421 6.9476 4.04706 7.6743 3.74365L7.73378 3.72198C8.4549 3.42415 8.92636 2.72508 8.92636 1.93932C8.92636 1.45697 9.32224 1.0613 9.80485 1.0613H11.2198C11.7024 1.0613 12.0983 1.45139 12.0983 1.93932C12.0983 2.72508 12.5642 3.42353 13.2909 3.71641L13.5077 3.23406L13.356 3.73808C14.0771 4.03591 14.8955 3.87864 15.4481 3.33189L15.4592 3.32074C15.8012 2.97957 16.3594 2.97957 16.7008 3.32074L17.6982 4.31765C18.0402 4.65944 18.0402 5.21176 17.6926 5.55851C17.1394 6.11641 16.9771 6.93498 17.2751 7.65511L17.3023 7.72012C17.6003 8.44582 18.2998 8.91765 19.0859 8.91765C19.5685 8.91765 19.9644 9.31331 19.9644 9.79567V11.2043L19.965 11.2037Z" fill="#6A7988" />
                      <path d="M10.4949 5.60248C7.79011 5.60248 5.58398 7.80743 5.58398 10.5108C5.58398 13.2142 7.78453 15.4192 10.4949 15.4192C13.2054 15.4192 15.4065 13.2142 15.4059 10.5108C15.4059 7.80743 13.1998 5.60248 10.4949 5.60248ZM10.4949 14.3635C8.36998 14.3635 6.63532 12.6297 6.63532 10.5059C6.63532 8.38204 8.36441 6.6483 10.4949 6.6483C12.6255 6.6483 14.3546 8.38204 14.3546 10.5059C14.3546 12.6297 12.6199 14.3635 10.4949 14.3635Z" fill="#6A7988" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1143_332">
                        <rect width="21" height="21" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Manage Categories
              </a>
            </div>
          </div>

          {/* Sum of all currencies module */}

          <div className="overview-top-inner">
            <div className="overview-top-left">
              <a className="btn-forpop-initem"
                onClick={handleOpenCreateModal}
              >
                <span className="icon-invoice">
                  <img src={PlusIcon} alt="Add new Expense " />
                </span>
                New Expense
              </a>

              <Modal
                className="client-modal sprint-modal sprint-modal-expense"
                isOpen={isCreateModalOpen}
                onRequestClose={!isSubmitLoading ? handleCloseCreateModal : undefined}
                contentLabel="Create  Expense"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-40%, -50%)",
                    parent: document.querySelector(".admin-outer.time.tracker"),
                  },
                }}
              >
                <div className="modal timeoff-modal">
                  <div className="modal-close-invite outter-modal-main">
                    <a className="" onClick={handleCloseCreateModal} disabled={isSubmitLoading}>
                      <img src={crssrImage} alt="Edit Icon" />{" "}
                    </a>
                  </div>
                  <div className="modal-client-head">
                    <h2 className="">New Expense</h2>
                  </div>
                  <div className="form-field-client-outer profile-details-edit expense-modal-scroll">
                    <div className="form-field-client" >
                      <label htmlFor="projectName" className="form-label">
                        Date
                      </label>
                      <div className="date-picker-outer date-picker-outer-all">
                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <DatePicker
                            oneTap
                            format="dd/MM/yyyy"
                            ranges={ranges}
                            value={expenseDate}
                            onChange={handleDateChange}
                            placement="auto"
                            className="invoice-filter-top-date"
                            isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === 'Monday'}
                            timeZone={global.config.getTimeZone()}
                            disabledDate={disabledDate}
                          />
                        </div>
                        <div className="custom-picker-icon custom-picker-icon-all">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            class="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>
                      </div>

                      {expenseDateIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Select the Expense date
                        </span>
                      )}
                    </div>
                    <div className="form-field-client">
                      <label htmlFor="category" className="form-label">
                        Category
                      </label>

                      {isLoadingExpCategory == true ? (
                        <div className="outter-load-table">
                          <ThreeDots
                            height="18"
                            width="20"
                            radius="9"
                            color="#405BFF"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible={true}
                          />
                        </div>
                      ) : (
                        <div
                          ref={expenseCategoryDropdownRef}
                          className={`cursor ${expenseCategoryDropdownOpen ? 'open' : ''}`}
                        >
                          <span
                            id="user-select"
                            onClick={() => setExpenseCategoryDropdownOpen(!expenseCategoryDropdownOpen)}
                            className={`custom-dropdown-user-new custom-dropdown-select ${expenseCategoryIsValid ? 'input-validation-error' : ''}`}
                            ref={expenseCategoryRef}
                          >
                            {expCategory ? expenseCategory.find((exp) => exp._id === expCategory)?.exp_category_name : 'Select'}
                          </span>
                          {expenseCategoryDropdownOpen && (
                            <div className="custom-dropdown-new">
                              {expenseCategory && expenseCategory.length > 0 ? (
                                <ul className="leave-type-list">
                                  {expenseCategory &&
                                    expenseCategory
                                      .slice()
                                      .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                      .map((exp) => (
                                        <li
                                          key={exp._id}
                                          className={expCategory === exp._id ? 'selected-item' : ''}
                                          onClick={() => {
                                            setExpCategory(exp._id);
                                            setExpenseCategoryDropdownOpen(false);
                                          }}
                                        >
                                          {exp.exp_category_name}
                                        </li>
                                      ))}
                                </ul>
                              ) : (
                                <div className="text-gray-500 text-sm italic">No categories available</div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      {expenseCategoryIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Equipment Category Field Cannot be empty
                        </span>
                      )}
                    </div>
                    <div className="form-field-client">
                      <label htmlFor="client" className="form-label">
                        Currency
                      </label>
                      <div ref={expCurrencyDropdownRef} className={`cursor ${expCurrencyDropdownOpen ? 'open' : ''}`} >
                        <span
                          id="user-select"
                          onClick={handleToggleExpCurrencyDropdown}
                          className={`custom-dropdown-user-new custom-dropdown-user ${expenseCurrencyIsValid ? 'input-validation-error' : ''}`}
                          ref={expenseCurrencyRef}
                        >
                          {expCurrency ? expCurrencyList.find((c) => c.currencyCode === expCurrency)?.currencyCode : 'Select Currency'}
                        </span>
                        {expCurrencyDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <input
                              type="text"
                              className="search-bar"
                              placeholder="Search..."
                              value={expCurrencySearchTerm}
                              onChange={handleExpCurrencySearchInputChange}
                            />
                            <ul className="currency-list">
                              {filteredExpCurrencies.length > 0 &&
                                filteredExpCurrencies.map((c) => (
                                  <li
                                    key={c.currencyCode}
                                    className={expCurrency === c.currencyCode ? 'selected-item' : ''}
                                    onClick={() => {
                                      setExpCurrency(c.currencyCode);
                                      setExpCurrencyDropdownOpen(false);
                                    }}
                                  >
                                    {`${c.currencyCode} (${c.currencyName})`}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>

                      {expenseCurrencyIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Expense currency needs to be selected
                        </span>
                      )}
                    </div>

                    <button type="submit" className="submit-client" disabled={isSubmitLoading} onClick={expenseSubmit}>
                      {isSubmitLoading ?
                        <div className="outter-load-table">
                          <ThreeDots
                            height="18"
                            width="20"
                            radius="9"
                            color="white"
                            ariaLabel="three-dots-loading"
                            wrapperStyle={{}}
                            wrapperClassName=""
                            visible={true}
                          />
                        </div> : 'Create Expense'}
                    </button>
                  </div>
                </div>
              </Modal>

              <a onClick={exportToExcel}>
                <span className="icon-export">
                  <img src={DownloadImage} alt="Export" />
                </span>
                Export Data
              </a>
            </div>

            <div className="overview-top-right expense-overview">
              <div className="showing-count">
                <div className="filter-inner showing-result">
                  <label>Showing</label>
                  <div ref={showingDropdownRef} className="select-modal-mainM custom-dropdown-user-new-outer">
                    <div className="selected-option custom-dropdown-user-new" onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}>
                      {totalResults < 10 ? totalResults.toString() : perPage.toString()}
                    </div>
                    {showingDropdownOpen && (
                      <div className="custom-dropdown-new">
                        <ul className="showing-options-list">
                          {totalResults >= 10 && <li className={perPage === 10 ? 'selected-item' : ''} onClick={() => { setPerPages(10); setShowingDropdownOpen(false); }}>10</li>}
                          {totalResults >= 20 && <li className={perPage === 20 ? 'selected-item' : ''} onClick={() => { setPerPages(20); setShowingDropdownOpen(false); }}>20</li>}
                          {totalResults >= 30 && <li className={perPage === 30 ? 'selected-item' : ''} onClick={() => { setPerPages(30); setShowingDropdownOpen(false); }}>30</li>}
                          {totalResults >= 40 && <li className={perPage === 40 ? 'selected-item' : ''} onClick={() => { setPerPages(40); setShowingDropdownOpen(false); }}>40</li>}
                          {totalResults >= 10 && <li className={totalResults >= 10 && perPage === totalResults ? 'selected-item' : ''} onClick={() => { setPerPages(totalResults); setShowingDropdownOpen(false); }}>ALL</li>}
                          {/* Add more conditions as needed */}
                          {totalResults < 10 ? (
                            <li className={totalResults < 10 ? 'selected-item' : ''} onClick={() => { setPerPages(totalResults); setShowingDropdownOpen(false); }}>{totalResults}</li>
                          ) : null}
                        </ul>
                      </div>
                    )}
                  </div>
                  <label>of {expenseDatas.length} Results</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="overview-inner-section">
          <div className={`filter-sec-overview active`}>
            <div className="invoice-filter-inner">
              <div className="invoice-filter-inner-section no-flter-all">
                {(user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN || user.userType === userTypeConsts.PROJECT_MANAGER || user.userType === userTypeConsts.TEAM_MANAGER)) && (
                  <div className="filter-inner invoice-id">
                    <label>Team</label>
                    <div className="custom-dropdown1" ref={teamDropdownRef}>
                      <div className="drop-down-inner">
                        <div className="selected-options1" onClick={toggleTeamDropdown}>
                          {selectedTeams.length === 0 ? (
                            <div className="placeholder">Select</div>
                          ) : (
                            <>
                              <div className="selected-option1" key={selectedTeams[0]}>
                                {selectedTeams.length === teams.length
                                  ? 'All'
                                  : (<>
                                    <TruncateFilterFieldView textContent={
                                      teams.find((item) => item._id === selectedTeams[0])?.first_name
                                        ? `${teams.find((item) => item._id === selectedTeams[0]).first_name} ${teams.find((item) => item._id === selectedTeams[0]).middle_name
                                          ? teams.find((item) => item._id === selectedTeams[0]).middle_name
                                          : ''
                                        } ${teams.find((item) => item._id === selectedTeams[0]).last_name
                                          ? teams.find((item) => item._id === selectedTeams[0]).last_name
                                          : ''
                                        }`
                                        : (
                                          teams.find((item) => item._id === selectedTeams[0])?.company_first_name
                                            ? `${teams.find((item) => item._id === selectedTeams[0]).company_first_name} ${teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                              ? teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                              : ''
                                            }`
                                            : `${teams.find((item) => item._id === selectedTeams[0])?.company_name} (Company)`
                                        )
                                    } />
                                    {selectedTeams.length > 1 && selectedTeams.length !== teams.length && (
                                      <div className="selected-option-count">
                                        {selectedTeams.length - 1}+
                                      </div>
                                    )}
                                  </>)}
                              </div>
                            </>
                          )}
                        </div>
                        {isTeamDropdownOpen && (
                          <div className="dropdown-list1">
                            <input
                              type="text"
                              placeholder="Search teams"
                              value={userDropdownSearchTerm}
                              onChange={handleUserDropdownSearchChange}
                              className="search-bar"
                            />
                            {filteredDropdownUsers.length > 0 && (
                              <>
                                {userDropdownSearchTerm === "" && (
                                  <label className="checkbox-label1" key="selectAll">
                                    <input
                                      type="checkbox"
                                      checked={selectAllTeam}
                                      onChange={handleSelectAllTeamChange}
                                    />
                                    All Teams
                                  </label>
                                )}
                                {filteredDropdownUsers
                                  .map((team) => (
                                    <label className="checkbox-label1" key={team._id}>
                                      <input
                                        type="checkbox"
                                        checked={selectedTeams.includes(team._id)}
                                        onChange={() => handleCheckboxTeamChange(team._id)}
                                      />
                                      {team.first_name ? `${team.first_name} ${team.middle_name ? team.middle_name : ''} ${team.last_name}` : (team.company_first_name ? `${team.company_first_name} ${team.company_last_name ? team.company_last_name : ''}` : `${team.company_name} (Company)`)}
                                    </label>
                                  ))}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="filter-inner user">
                  <label for="user">Client</label>
                  <div className="custom-dropdown1" ref={clientDropdownRef}>
                    <div className="drop-down-inner">
                      <div className="selected-options1" onClick={toggleClientDropdown}>

                        {selectedClients.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedClients[0]}>
                              {selectedClients.length === clients.length
                                ? 'All'
                                : (
                                  <>
                                    <TruncateFilterFieldView textContent={clients.find((item) => item._id === selectedClients[0])?.client_name} />
                                    {selectedClients.length > 1 && selectedClients.length !== clients.length && (
                                      <div className="selected-option-count">
                                        {selectedClients.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>
                          </>
                        )}

                      </div>
                      {isClientDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search clients"
                            value={clientDropdownSearchTerm}
                            onChange={handleClientDropdownSearchChange}
                            className="search-bar"
                          />
                          {filteredDropdownClients.length > 0 && (
                            <>
                              {clientDropdownSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllClient}
                                    onChange={handleSelectAllClientChange}
                                  />
                                  All Clients
                                </label>
                              )}
                              {filteredDropdownClients
                                .slice()
                                .sort((a, b) =>
                                  a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
                                )
                                .map((client) => (
                                  <label className="checkbox-label1" key={client._id}>
                                    <input
                                      type="checkbox"
                                      checked={selectedClients.includes(client._id)}
                                      onChange={() => handleCheckboxClientChange(client._id)}
                                    />
                                    {client.client_name && `${client.client_name}`}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="filter-inner payment-status">
                  <label for="paymentStatus">Department</label>
                  <div className="custom-dropdown1" ref={deptDropdownRef}>
                    <div className="drop-down-inner">
                      <div className="selected-options1" onClick={toggleDeptDropdown}>
                        {selectedDepts.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedDepts[0]}>
                              {selectedDepts.length === departments.length
                                ? 'All'
                                : (
                                  <>
                                    <TruncateFilterFieldView textContent={departments.find((item) => item._id === selectedDepts[0])?.user_department} />
                                    {selectedDepts.length > 1 && selectedDepts.length !== departments.length && (
                                      <div className="selected-option-count">
                                        {selectedDepts.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>

                          </>
                        )}
                      </div>
                      {isDeptDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search departments"
                            value={departmentDropdownSearchTerm}
                            onChange={handleDepartmentDropdownSearchChange}
                            className="search-bar"
                          />
                          {filteredDropdownDepartments.length > 0 && (
                            <>
                              {departmentDropdownSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllDept}
                                    onChange={handleSelectAllDeptChange}
                                  />
                                  All Departments
                                </label>
                              )}
                              {filteredDropdownDepartments
                                .slice()
                                .sort((a, b) => a.user_department?.toLowerCase().localeCompare(b.user_department?.toLowerCase()))
                                .map((dept) => (
                                  <label className="checkbox-label1" key={dept._id}>
                                    <input
                                      type="checkbox"
                                      checked={selectedDepts.includes(dept._id)}
                                      onChange={() => handleCheckboxDeptChange(dept._id)}
                                    />
                                    {dept.user_department && `${dept.user_department}`}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="filter-inner payment-status">
                  <label for="paymentStatus">Expense Category</label>
                  <div className="custom-dropdown1" ref={expCategoryDropdownRef}>
                    <div className="drop-down-inner">
                      <div className="selected-options1" onClick={toggleExpCategoryDropdown}>
                        {selectedExpCategories.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedExpCategories[0]}>
                              {selectedExpCategories.length === expenseCategory.length
                                ? 'All'
                                : (
                                  <>
                                    <TruncateFilterFieldView textContent={expenseCategory.find((item) => item._id === selectedExpCategories[0])?.exp_category_name} />
                                    {selectedExpCategories.length > 1 && selectedExpCategories.length !== expenseCategory.length && (
                                      <div className="selected-option-count">
                                        {selectedExpCategories.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>

                          </>
                        )}
                      </div>
                      {isExpCategoryDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search categories"
                            value={categoryDropdownSearchTerm}
                            onChange={handleCategoryDropdownSearchChange}
                            className="search-bar"
                          />
                          {filteredDropdownExpenseCategory.length > 0 && (
                            <>
                              {categoryDropdownSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllExpCategory}
                                    onChange={handleSelectAllExpCategoryChange}
                                  />
                                  All Expense Category
                                </label>
                              )}
                              {filteredDropdownExpenseCategory
                                .slice()
                                .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                .map((expCat) => (
                                  <label className="checkbox-label1" key={expCat._id}>
                                    <input
                                      type="checkbox"
                                      checked={selectedExpCategories.includes(expCat._id)}
                                      onChange={() => handleCheckboxExpCategoryChange(expCat._id)}
                                    />
                                    {expCat.exp_category_name && `${expCat.exp_category_name}`}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="filter-inner payment-status">
                  <label for="paymentStatus">Expense Currency</label>
                  <div className="custom-dropdown1" ref={expCurrencyFilterDropdownRef}>
                    <div className="drop-down-inner">
                      <div className="selected-options1" onClick={toggleExpCurrencyFilterDropdown}>
                        {selectedExpCurrenciesFilter.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedExpCurrenciesFilter[0]}>
                              {selectedExpCurrenciesFilter.length === expCurrencyList.length
                                ? 'All'
                                : (
                                  <>
                                    <TruncateFilterFieldView textContent={expCurrencyList.find((item) => item.currencyCode === selectedExpCurrenciesFilter[0])?.currencyName} />
                                    {selectedExpCurrenciesFilter.length > 1 && selectedExpCurrenciesFilter.length !== expCurrencyList.length && (
                                      <div className="selected-option-count">
                                        {selectedExpCurrenciesFilter.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>

                          </>
                        )}
                      </div>
                      {isExpCurrencyFilterDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search currency"
                            value={expCurrencyDropdownSearchTerm}
                            onChange={handleExpCurrencyDropdownSearchChange}
                            className="search-bar"
                          />
                          {filteredDropdownExpCurrencyList.length > 0 && (
                            <>
                              {expCurrencyDropdownSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllExpCurrencyFilter}
                                    onChange={handleSelectAllExpCurrencyFilterChange}
                                  />
                                  All
                                </label>
                              )}
                              {filteredDropdownExpCurrencyList
                                .slice()
                                .sort((a, b) => a.currencyName?.toLowerCase().localeCompare(b.currencyName?.toLowerCase()))
                                .map((expCur) => (
                                  <label className="checkbox-label1" key={expCur.currencyCode}>
                                    <input
                                      type="checkbox"
                                      checked={selectedExpCurrenciesFilter.includes(expCur.currencyCode)}
                                      onChange={() => handleCheckboxExpCurrencyFilterChange(expCur.currencyCode)}
                                    />
                                    {expCur.currencyCode && `${expCur.currencyCode} (${expCur.currencyName})`}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="filter-inner payment-status">
                  <label htmlFor="expenseStatus">Expense Status</label>
                  <div className="custom-dropdown1" ref={expStatusFilterDropdownRef}>
                    <div className="drop-down-inner">
                      <div className="selected-options1" onClick={toggleExpStatusFilterDropdown}>
                        {selectedExpStatusFilter.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <>
                            <div className="selected-option1" key={selectedExpStatusFilter[0]}>
                              {selectedExpStatusFilter.length === expenseStatusList.length
                                ? 'All'
                                : (
                                  <>
                                    <TruncateFilterFieldView textContent={expenseStatusList.find((item) => item.value === selectedExpStatusFilter[0])?.label} />
                                    {selectedExpStatusFilter.length > 1 && selectedExpStatusFilter.length !== expenseStatusList.length && (
                                      <div className="selected-option-count">
                                        {selectedExpStatusFilter.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                            </div>
                          </>
                        )}
                      </div>

                      {isExpStatusFilterDropdownOpen && (
                        <div className="dropdown-list1">
                          <input
                            type="text"
                            placeholder="Search status"
                            value={expStatusDropdownSearchTerm}
                            onChange={handleExpStatusDropdownSearchChange}
                            className="search-bar"
                          />
                          {filteredExpStatusList.length > 0 && (
                            <>
                              {expStatusDropdownSearchTerm === "" && (
                                <label className="checkbox-label1" key="selectAllStatus">
                                  <input
                                    type="checkbox"
                                    checked={selectAllExpStatusFilter}
                                    onChange={handleSelectAllExpStatusFilterChange}
                                  />
                                  All
                                </label>
                              )}
                              {filteredExpStatusList
                                .slice()
                                .sort((a, b) => a.label?.toLowerCase().localeCompare(b.label?.toLowerCase()))
                                .map((status) => (
                                  <label className="checkbox-label1" key={status.value}>
                                    <input
                                      type="checkbox"
                                      checked={selectedExpStatusFilter.includes(status.value)}
                                      onChange={() => handleCheckboxExpStatusFilterChange(status.value)}
                                    />
                                    {status.label}
                                  </label>
                                ))}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="filter-inner due-date dd">

                  <label htmlFor="dueDate" className="calendar-icon">
                    Date Range
                  </label>
                  <div className="date-picker-outer date-picker-outer-all" ref={calendarRef}>
                    <div className="custom-picker-icon custom-picker-icon-all">
                      <svg
                        width="1em"
                        height="1em"
                        viewBox="0 0 14 14"
                        fill="currentColor"
                        aria-hidden="true"
                        focusable="false"
                        class="rs-picker-toggle-caret rs-icon"
                        aria-label="calendar"
                        data-category="legacy"
                      >
                        <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                      </svg>
                    </div>
                    <div className="custoom-icon-calender custoom-icon-calender-all">

                      <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">
                        <input
                          type="text"
                          value={

                            dateRange ?
                              `${new Date(dateRange[0]).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })} to ${new Date(dateRange[1]).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              })}`
                              : null
                          }

                          id="invoiceId"
                          name="invoiceId"
                          placeholder="All Time"
                          onClick={toggleCalendar}
                          autocomplete="off"
                        />
                      </div>
                      <div className="date-range-new right-align">
                        {showCalendar && <Calendar onCancel={cancelCalendar} onChange={onDateChange} initialRange={{ startDate: dateRange ? dateRange[0] : null, endDate: dateRange ? dateRange[1] : null }} />}
                      </div>
                    </div>
                  </div>


                </div>
              </div>
              <div className="filter-invoice-right apply-fliter-right">
                <button onClick={toggleFilterModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="17"
                    viewBox="0 0 13 17"
                    fill="none"
                  >
                    <path
                      d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                      fill="#6479F8"
                    />
                    <path
                      d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                      fill="#6479F8"
                    />
                    <path
                      d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                      fill="#6479F8"
                    />
                  </svg>
                  All Filters
                </button>
              </div>
              <Modal
                isOpen={showFilterModal}
                onRequestClose={checkAndShowConfirmationModal}
                contentLabel="Filter Modal"
                className="new-filter-modal"
                style={{
                  content: {
                    height: "50%",
                    width: "50%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-25%, -25%)",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    padding: "20px",
                  },
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  },
                }}
              >
                <div className="new-nodal-invoice-outer-sec">

                  <div className="new-modal-top-sec">
                    <div className="new-modal-heading">
                      All filters
                    </div>
                    <a className="close-image-clr1" onClick={checkAndShowConfirmationModal}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1 13L13 1" stroke="black" />
                        <path d="M1 0.999999L13 13" stroke="black" />
                      </svg>{" "}
                    </a>
                  </div>
                  <div className="invoice-filter-inner-section">
                    {(user && (user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN || user.userType === userTypeConsts.PROJECT_MANAGER || user.userType === userTypeConsts.TEAM_MANAGER)) && (
                      <div className="filter-inner invoice-id">
                        <label>Team</label>
                        <div className="custom-dropdown1" ref={teamModalDropdownRef}>
                          <div className="drop-down-inner">
                            <div className="selected-options1" onClick={toggleTeamModalDropdown}>
                              {selectedTeams.length === 0 ? (
                                <div className="placeholder">Select</div>
                              ) : (
                                <>
                                  <div className="selected-option1" key={selectedTeams[0]}>
                                    {selectedTeams.length === teams.length
                                      ? 'All'
                                      : (<>
                                        <TruncateFilterFieldView textContent={
                                          teams.find((item) => item._id === selectedTeams[0])?.first_name
                                            ? `${teams.find((item) => item._id === selectedTeams[0]).first_name} ${teams.find((item) => item._id === selectedTeams[0]).middle_name
                                              ? teams.find((item) => item._id === selectedTeams[0]).middle_name
                                              : ''
                                            } ${teams.find((item) => item._id === selectedTeams[0]).last_name
                                              ? teams.find((item) => item._id === selectedTeams[0]).last_name
                                              : ''
                                            }`
                                            : (
                                              teams.find((item) => item._id === selectedTeams[0])?.company_first_name
                                                ? `${teams.find((item) => item._id === selectedTeams[0]).company_first_name} ${teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                                  ? teams.find((item) => item._id === selectedTeams[0]).company_last_name
                                                  : ''
                                                }`
                                                : `${teams.find((item) => item._id === selectedTeams[0])?.company_name} (Company)`
                                            )
                                        } />
                                        {selectedTeams.length > 1 && selectedTeams.length !== teams.length && (
                                          <div className="selected-option-count">
                                            {selectedTeams.length - 1}+
                                          </div>
                                        )}
                                      </>)}
                                  </div>
                                </>
                              )}
                            </div>
                            {isTeamModalDropdownOpen && (
                              <div className="dropdown-list1">
                                <input
                                  type="text"
                                  placeholder="Search teams"
                                  value={userDropdownSearchTerm}
                                  onChange={handleUserDropdownSearchChange}
                                  className="search-bar"
                                />
                                {filteredDropdownUsers.length > 0 && (
                                  <>
                                    {userDropdownSearchTerm === "" && (
                                      <label className="checkbox-label1" key="selectAll">
                                        <input
                                          type="checkbox"
                                          checked={selectAllTeam}
                                          onChange={handleSelectAllTeamChange}
                                        />
                                        All Teams
                                      </label>
                                    )}
                                    {filteredDropdownUsers
                                      .map((team) => (
                                        <label className="checkbox-label1" key={team._id}>
                                          <input
                                            type="checkbox"
                                            checked={selectedTeams.includes(team._id)}
                                            onChange={() => handleCheckboxTeamChange(team._id)}
                                          />
                                          {team.first_name ? `${team.first_name} ${team.middle_name ? team.middle_name : ''} ${team.last_name}` : (team.company_first_name ? `${team.company_first_name} ${team.company_last_name ? team.company_last_name : ''}` : `${team.company_name} (Company)`)}
                                        </label>
                                      ))}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="filter-inner user">
                      <label for="user">Client</label>
                      <div className="custom-dropdown1" ref={clientModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleClientModalDropdown}>
                            {selectedClients.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div className="selected-option1" key={selectedClients[0]}>
                                  {selectedClients.length === clients.length
                                    ? 'All'
                                    : (
                                      <>
                                        <TruncateFilterFieldView textContent={clients.find((item) => item._id === selectedClients[0])?.client_name} />
                                        {selectedClients.length > 1 && selectedClients.length !== clients.length && (
                                          <div className="selected-option-count">
                                            {selectedClients.length - 1}+
                                          </div>
                                        )}
                                      </>
                                    )}
                                </div>
                              </>
                            )}
                          </div>
                          {isClientModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search clients"
                                value={clientDropdownSearchTerm}
                                onChange={handleClientDropdownSearchChange}
                                className="search-bar"
                              />
                              {filteredDropdownClients.length > 0 && (
                                <>
                                  {clientDropdownSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll">
                                      <input
                                        type="checkbox"
                                        checked={selectAllClient}
                                        onChange={handleSelectAllClientChange}
                                      />
                                      All Clients
                                    </label>
                                  )}
                                  {filteredDropdownClients
                                    .slice()
                                    .sort((a, b) =>
                                      a.client_name?.toLowerCase().localeCompare(b.client_name?.toLowerCase())
                                    )
                                    .map((client) => (
                                      <label className="checkbox-label1" key={client._id}>
                                        <input
                                          type="checkbox"
                                          checked={selectedClients.includes(client._id)}
                                          onChange={() => handleCheckboxClientChange(client._id)}
                                        />
                                        {client.client_name && `${client.client_name}`}
                                      </label>
                                    ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner payment-status">
                      <label for="paymentStatus">Department</label>
                      <div className="custom-dropdown1" ref={deptModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleDeptModalDropdown}>
                            {selectedDepts.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div className="selected-option1" key={selectedDepts[0]}>
                                  {selectedDepts.length === departments.length
                                    ? 'All'
                                    : (
                                      <>
                                        <TruncateFilterFieldView textContent={departments.find((item) => item._id === selectedDepts[0])?.user_department} />
                                        {selectedDepts.length > 1 && selectedDepts.length !== departments.length && (
                                          <div className="selected-option-count">
                                            {selectedDepts.length - 1}+
                                          </div>
                                        )}
                                      </>
                                    )}
                                </div>

                              </>
                            )}
                          </div>
                          {isDeptModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search departments"
                                value={departmentDropdownSearchTerm}
                                onChange={handleDepartmentDropdownSearchChange}
                                className="search-bar"
                              />
                              {filteredDropdownDepartments.length > 0 && (
                                <>
                                  {departmentDropdownSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll">
                                      <input
                                        type="checkbox"
                                        checked={selectAllDept}
                                        onChange={handleSelectAllDeptChange}
                                      />
                                      All Departments
                                    </label>
                                  )}
                                  {filteredDropdownDepartments
                                    .slice()
                                    .sort((a, b) => a.user_department?.toLowerCase().localeCompare(b.user_department?.toLowerCase()))
                                    .map((dept) => (
                                      <label className="checkbox-label1" key={dept._id}>
                                        <input
                                          type="checkbox"
                                          checked={selectedDepts.includes(dept._id)}
                                          onChange={() => handleCheckboxDeptChange(dept._id)}
                                        />
                                        {dept.user_department && `${dept.user_department}`}
                                      </label>
                                    ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner payment-status">
                      <label for="paymentStatus">Expense Category</label>
                      <div className="custom-dropdown1" ref={expCategoryModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleExpCategoryModalDropdown}>
                            {selectedExpCategories.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <div className="selected-option1" key={selectedExpCategories[0]}>
                                {selectedExpCategories.length === expenseCategory.length
                                  ? 'All'
                                  : (
                                    <>
                                      <TruncateFilterFieldView textContent={expenseCategory.find((item) => item._id === selectedExpCategories[0])?.exp_category_name} />
                                      {selectedExpCategories.length > 1 && selectedExpCategories.length !== expenseCategory.length && (
                                        <div className="selected-option-count">
                                          {selectedExpCategories.length - 1}+
                                        </div>
                                      )}
                                    </>
                                  )}
                              </div>
                            )}
                          </div>
                          {isExpCategoryModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search categories"
                                value={categoryDropdownSearchTerm}
                                onChange={handleCategoryDropdownSearchChange}
                                className="search-bar"
                              />
                              {filteredDropdownExpenseCategory.length > 0 && (
                                <>
                                  {categoryDropdownSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll">
                                      <input
                                        type="checkbox"
                                        checked={selectAllExpCategory}
                                        onChange={handleSelectAllExpCategoryChange}
                                      />
                                      All
                                    </label>
                                  )}
                                  {filteredDropdownExpenseCategory
                                    .slice()
                                    .sort((a, b) => a.exp_category_name?.toLowerCase().localeCompare(b.exp_category_name?.toLowerCase()))
                                    .map((expCat) => (
                                      <label className="checkbox-label1" key={expCat._id}>
                                        <input
                                          type="checkbox"
                                          checked={selectedExpCategories.includes(expCat._id)}
                                          onChange={() => handleCheckboxExpCategoryChange(expCat._id)}
                                        />
                                        {expCat.exp_category_name && `${expCat.exp_category_name}`}
                                      </label>
                                    ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="filter-inner payment-status">
                      <label for="paymentStatus">Expense Currency </label>
                      <div className="custom-dropdown1" ref={expCurrencyFilterModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleExpCurrencyFilterModalDropdown}>
                            {selectedExpCurrenciesFilter.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div className="selected-option1" key={selectedExpCurrenciesFilter[0]}>
                                  {selectedExpCurrenciesFilter.length === expCurrencyList.length
                                    ? 'All'
                                    : (
                                      <>
                                        <TruncateFilterFieldView textContent={expCurrencyList.find((item) => item.currencyCode === selectedExpCurrenciesFilter[0])?.currencyName} />
                                        {selectedExpCurrenciesFilter.length > 1 && selectedExpCurrenciesFilter.length !== expCurrencyList.length && (
                                          <div className="selected-option-count">
                                            {selectedExpCurrenciesFilter.length - 1}+
                                          </div>
                                        )}
                                      </>
                                    )}
                                </div>

                              </>
                            )}
                          </div>
                          {isExpCurrencyFilterModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <input
                                type="text"
                                placeholder="Search currency"
                                value={expCurrencyDropdownSearchTerm}
                                onChange={handleExpCurrencyDropdownSearchChange}
                                className="search-bar"
                              />
                              {filteredDropdownExpCurrencyList.length > 0 && (
                                <>
                                  {expCurrencyDropdownSearchTerm === "" && (
                                    <label className="checkbox-label1" key="selectAll">
                                      <input
                                        type="checkbox"
                                        checked={selectAllExpCurrencyFilter}
                                        onChange={handleSelectAllExpCurrencyFilterChange}
                                      />
                                      All Expense Currency
                                    </label>
                                  )}
                                  {filteredDropdownExpCurrencyList
                                    .slice()
                                    .sort((a, b) => a.currencyName?.toLowerCase().localeCompare(b.currencyName?.toLowerCase()))
                                    .map((expCur) => (
                                      <label className="checkbox-label1" key={expCur.currencyCode}>
                                        <input
                                          type="checkbox"
                                          checked={selectedExpCurrenciesFilter.includes(expCur.currencyCode)}
                                          onChange={() => handleCheckboxExpCurrencyFilterChange(expCur.currencyCode)}
                                        />
                                        {expCur.currencyCode && `${expCur.currencyCode} (${expCur.currencyName})`}
                                      </label>
                                    ))}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>


                    <div className="filter-inner due-date cc">
                      <label htmlFor="dueDate" className="calendar-icon">
                        Date Range
                      </label>
                      <div className="date-picker-outer date-picker-outer-all" ref={calendarModalRef}>
                        <div className="custom-picker-icon custom-picker-icon-all">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            class="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>
                        <div className="custoom-icon-calender custoom-icon-calender-all 33">
                          <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">
                            <input
                              type="text"
                              value={
                                dateRange ?
                                  `${new Date(dateRange[0]).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })} to ${new Date(dateRange[1]).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}`
                                  : null
                              }
                              id="invoiceId"
                              name="invoiceId"
                              placeholder="All Time"
                              onClick={toggleModalCalendar}
                              autocomplete="off"
                            />
                          </div>
                          <div className="date-range-new">
                            {showModalCalendar && <Calendar onCancel={cancelModalCalendar} onChange={onDateChange} initialRange={{ startDate: dateRange ? dateRange[0] : null, endDate: dateRange ? dateRange[1] : null }} />}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <Modal
                  className="delete-modal"
                  isOpen={showConfirmationModal}
                  onRequestClose={handleCancel}
                  contentLabel="Confirm Delete"
                  style={{
                    content: {
                      height: "41%",
                      width: "30%",
                      position: "fixed",
                      top: "36%",
                      left: "50%",
                      transform: "translate(-24.75%, 0%)",
                      parent: document.querySelector(".admin-outer.time.tracker"),
                    },
                  }}
                >
                  <div className="delete-modal-content">
                    <h2>Apply or Discard changes?</h2>
                    <p>
                      Do you want to Apply or Discard filter changes?
                    </p>

                    <div className="delete-modal-buttons">
                      <button className="delete" onClick={handleApplyConfirm} >
                        Apply Changes
                      </button>
                      <button onClick={clearFilters}>
                        Discard Changes
                      </button>
                    </div>
                  </div>
                </Modal>
                <div className="filter-buttons">
                  <button className="clear-all" onClick={clearFilters}>Clear All</button>
                  <button className="apply-filter" onClick={applyFilters}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                      <path d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z" fill="white" />
                      <path d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z" fill="white" />
                      <path d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z" fill="white" />
                    </svg>
                    Apply Filters
                  </button>
                </div>
              </Modal>
            </div>
          </div>
        </div>

        <div className="overview-outer-sec-time tab-inner-time">
          <div className="total-sec-overview">
            <ExpenseOverviewTotal expCategories={selectedExpCategories} expenseData={expenseDatas} isLoading={expenseLoading} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
          </div>
          <div className="graph-piechart">
            <div className="overview-graph-time">
              <ExpenseOverviewGraph graphDate={dateRange ? dateRange[1] : null} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
            </div>
            <div className="piechart">
              <ExpenseOverviewPieChart expenseData={expenseDatas} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
            </div>
          </div>
          <div className="time-table-section time-table-section-project-client">
            <ExpenseTable expenseData={expenseDatas} perPage={perPage} graphDate={dateRange} user={user} isLoading={expenseLoading} queryClient={queryClient} allCurrency={allCurrency} selectedCurrency={selectedCurrency} />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ExpenseOverview;